module.exports = __webpack_public_path__ + "static/media/stats_icon_banner_dark.8be98a97.svg";